export const abi = [
  {
    type: 'function',
    name: 'PROXY_getImplementation',
    inputs: [],
    outputs: [{ name: '', type: 'address', internalType: 'address' }],
    stateMutability: 'view'
  }
] as const
